import * as req from 'api/actions';
import moment from 'moment';
import * as c from './constant';

export const getTotalStatsIncident = (payload, callback) =>
  req.item(
    c.GET_TOTAL_STATS_INCIDENT,
    'api/v1/administrators/incident_report/statistics',
    payload,
    callback
  );

export const getTotalStatsCovidVaccine = (payload, callback) =>
  req.item(
    c.GET_TOTAL_STATS_COVID_VACCINE,
    'api/v1/administrators/covid_vaccine_registration/statistics',
    payload,
    callback
  );

export const getGraphStats = (
  payload = {
    period: 'MONTHLY',
    date_from: moment().startOf('year').format('YYYY-MM-DD'),
    date_to: moment().endOf('year').format('YYYY-MM-DD'),
  },
  callback
) =>
  req.list(
    c.GET_GRAPH_STATS,
    'api/v1/administrators/incident_report/graph',
    payload,
    callback
  );


export const getVaccineRegistrationGraph = (
  payload = {
    period: 'MONTHLY',
    date_from: moment().startOf('year').format('YYYY-MM-DD'),
    date_to: moment().endOf('year').format('YYYY-MM-DD'),
  },
  callback
) =>
  req.list(
    c.GET_VACCINE_REGISTRATION_GRAPH,
    'api/v1/administrators/covid_vaccine_registration/graph',
    payload,
    callback
  );